





































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {deleteTown} from '@/ts/restaurants/delete-restaurant';

export default {
    name: 'TheTableRestaurants',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        fireModal(ekatte) {
            this.$swal.fire({
                title: 'Внимание!',
                text: 'Това действие е необратимо, желаете ли да продължите?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отказ',
                confirmButtonText: 'Изтриване',
            }).then((result) => {
                if (result.value) {
                    deleteTown(this.$route.params.id, ekatte).then(() => {
                        this.$swal.fire(
                            'Изтриването успешно!',
                            '',
                            'success',
                        );
                        const index = this.towns.findIndex((item) => item.id === ekatte);
                        this.towns.splice(index, index);
                    });
                }
            });
        },
    },
    computed: {
        towns() {
            const id = this.$route.params.id;
            return this.$store.getters.response.find((item) => item.id === id).relationships.delivery_towns.data;
        },
    },
};
